import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  fullWidth = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none uppercase tracking-wide';
  const variants = {
    primary: 'bg-brand-yellow text-brand-dark hover:bg-yellow-400 focus:ring-brand-yellow',
    secondary: 'bg-brand-dark text-white hover:bg-gray-800 focus:ring-brand-dark',
    outline: 'border-2 border-brand-dark text-brand-dark hover:bg-brand-light focus:ring-brand-dark',
    ghost: 'text-brand-dark hover:bg-brand-light hover:text-brand-dark'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-98">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-99" />}
      {children}
    </button>;
}